import { render, staticRenderFns } from "./yellowVData.vue?vue&type=template&id=0074ce10&scoped=true&"
import script from "./yellowVData.vue?vue&type=script&lang=js&"
export * from "./yellowVData.vue?vue&type=script&lang=js&"
import style0 from "./yellowVData.vue?vue&type=style&index=0&id=0074ce10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074ce10",
  null
  
)

export default component.exports